var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreySearchIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1268 16.5822L23.6899 22.1496V22.154C24.1027 22.5814 24.0968 23.2608 23.6766 23.681C23.2564 24.1011 22.577 24.107 22.1496 23.6942L16.5822 18.1268C12.3645 21.5237 6.22666 21.0282 2.60838 16.9989C-1.00991 12.9696 -0.844608 6.81402 2.9847 2.9847C6.81402 -0.844608 12.9696 -1.00991 16.9989 2.60838C21.0282 6.22666 21.5237 12.3645 18.1268 16.5822ZM7.15507 2.83011C4.16969 4.06657 2.22315 6.97968 2.22315 10.211C2.22795 14.6207 5.80122 18.1945 10.2109 18.1999C13.4422 18.2003 16.3556 16.2542 17.5925 13.269C18.8294 10.2837 18.1461 6.8474 15.8614 4.56237C13.5767 2.27734 10.1404 1.59365 7.15507 2.83011Z",
    fill: "#BDBDBD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreySearchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/greySearchIcon.bf5977d434b32ccf68347175a8785040.svg";